import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import {
  ChartLineUp, UsersThree, MapTrifold, CalendarBlank, Receipt, FileText,
  Scroll, GearSix, SignOut, Airplane, Notebook, ChartBar,
} from "@phosphor-icons/react";

const NAV = [
  { to: "/", label: "Dashboard", icon: ChartLineUp, testid: "nav-dashboard" },
  { to: "/clients", label: "Clientes", icon: UsersThree, testid: "nav-clients" },
  { to: "/inspections", label: "Inspeções", icon: MapTrifold, testid: "nav-inspections" },
  { to: "/calendar", label: "Calendário", icon: CalendarBlank, testid: "nav-calendar" },
  { to: "/invoices", label: "Faturamento", icon: Receipt, testid: "nav-invoices" },
  { to: "/reports", label: "Relatórios", icon: ChartBar, testid: "nav-reports" },
  { to: "/proposals", label: "Propostas", icon: FileText, testid: "nav-proposals" },
  { to: "/contracts", label: "Contratos", icon: Scroll, testid: "nav-contracts" },
  { to: "/templates", label: "Modelos", icon: Notebook, testid: "nav-templates" },
  { to: "/settings", label: "Configurações", icon: GearSix, testid: "nav-settings" },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <aside className="w-64 shrink-0 border-r border-border bg-card min-h-screen flex flex-col fixed left-0 top-0 bottom-0 z-30">
      <div className="p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <img src="/assets/logo.png" alt="SkyInspect" className="w-11 h-11 object-contain rounded-md bg-white/95 p-1" />
          <div>
            <div className="font-black text-lg leading-none tracking-tight" style={{ fontFamily: "Manrope" }}>SkyInspect</div>
            <div className="label-tech text-muted-foreground mt-1">Soluções em Drone</div>
          </div>
        </div>
      </div>

      <nav className="flex-1 py-4 px-3 space-y-1 overflow-y-auto">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            data-testid={item.testid}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-semibold transition-colors ${
                isActive
                  ? "bg-primary text-primary-foreground"
                  : "text-muted-foreground hover:text-foreground hover:bg-secondary"
              }`
            }
          >
            <item.icon size={18} weight="bold" />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-border">
        <div className="mb-3">
          <div className="text-xs text-muted-foreground">Logado como</div>
          <div className="text-sm font-semibold truncate" data-testid="sidebar-user-email">{user?.email}</div>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={handleLogout}
          data-testid="logout-btn"
          className="w-full justify-start gap-2"
        >
          <SignOut size={16} weight="bold" /> Sair
        </Button>
      </div>
    </aside>
  );
}
